import { defineStore, storeToRefs } from 'pinia'
import type { ComputedRef } from 'vue'
import { computed, ref } from 'vue'

const useContactUsStore = defineStore('contactUs', () => {
    const isOpen = ref(false)

    return {
        isOpen,
    }
})

type ContactUs = {
    open: () => void
    close: () => void
    isOpen: ComputedRef<boolean>
}

export function useContactUs(): ContactUs {
    const { isOpen } = storeToRefs(useContactUsStore())

    return {
        open: () => {
            isOpen.value = true
        },
        close: () => {
            isOpen.value = false
        },
        isOpen: computed(() => isOpen.value),
    }
}
